import Snackbar from 'node-snackbar';
import 'node-snackbar/dist/snackbar.css';

const DEFAULT_OPTIONS = {
  duration: 2750,
  actionText: 'Ok',
  pos: 'bottom-center',
};

function show(options) {
  if (!options) { return; }

  Snackbar.show({
    ...DEFAULT_OPTIONS,
    ...options,
  });
}

export default {
  show,
};



// WEBPACK FOOTER //
// ./src/snackbar.js